// Module
var code = "<div data-bind=\"visible: enable, click: action, event: { mouseover: hoverOn, mouseout: hoverOff }\">\r\n  <span class=\"cart-count\" params=\"count: count\"></span>\r\n  <bp-img class=\"link-icon\" params=\"iconName: icon\"></bp-img>\r\n  <span class=\"link-label\" data-bind=\"text: label\"></span>\r\n</div>\r\n";
// Exports
module.exports = code;